import LayoutActividad from "../../../components/LayoutActividad";
import Imagen1 from "../../../images/modulo3/futbolsexista.png";
import Imagen2 from "../../../images/modulo3/peleacolores.png";
import Imagen3 from "../../../images/modulo3/golpe.png";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { faComments } from "@fortawesome/free-solid-svg-icons";
import { modulo3 } from "../../../routes/Module3";
import Sidebar from "../Sidebar";
import GuiaDocente from "../../../components/GuiaDocente";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo3/Actividad 6.mp3";

const Actividad6 = () => {
  const infoUnidad = modulo3.content[0];
  const infoAct = modulo3.content[0].activities[5];
  const crumbs = [
    {
      title: modulo3.title,
      url: "/" + modulo3.url,
    },
    {
      title:
        modulo3.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];
  const pages = {
    titleNext: `${modulo3.content[0].activities[6].name}`,
    linkNext: `${modulo3.url}/${modulo3.content[0].path}/${modulo3.content[0].activities[6].path}`,
    titlePrev: `${modulo3.content[0].activities[4].name}`,
    linkPrev: `${modulo3.url}/${modulo3.content[0].path}/${modulo3.content[0].activities[4].path}`,
  };
  const metadata = {
    color: modulo3.color,
    title: `${modulo3.title} - ${infoAct.name}`,
    name: modulo3.title
  };
  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo3.color} hat-text`}>
          <FontAwesomeIcon icon={faComments} /> Dialogamos
        </small>
      </p>

      <h2 className="mb-5">Actividad 6</h2>
      <AudioPlayer track={Audio} />

      <ul className="my-5">
        <li>Trabaja con un compañero, compañera o familiar.</li>
        <li>Observen las ilustraciones.</li>
      </ul>

      <div className="row my-3 align-items-center">
        <div className="col-lg-8 col-12">
          <img src={Imagen1} alt="Familia" className="img-fluid" />
        </div>
      </div>
      <div className="row my-3 align-items-center">
        <div className="col-lg-8 col-12">
          <img src={Imagen2} alt="Familia" className="img-fluid" />
        </div>
      </div>
      <div className="row my-3 align-items-center">
        <div className="col-lg-8 col-12">
          <img src={Imagen3} alt="Familia" className="img-fluid" />
        </div>
      </div>
      <ul className="mt-5">
      <li>Ahora conversen sobre estas preguntas.</li>
      </ul>
      <div>¿Qué problema hay en cada escena?</div>
      <textarea className="form-control mt-1 mb-3" rows={3} />
      <div>¿Cómo se sienten las personas en cada escena?</div>
      <textarea className="form-control mt-1 mb-3" rows={3} />

      <div>¿Cómo se pueden solucionar los problemas?</div>
      <textarea className="form-control mt-1 mb-3" rows={3} />


      <GuiaDocente>
        <p>
          Lea las primeras indicaciones y observen las imágenes. De manera
          dialogada, para cada escena, identifiquen el problema, el efecto que
          tienen estos problemas en las personas y cuál sería una manera
          pacífica de resolverlos. Resalte que son problemas cotidianos en la
          escuela que afectan la convivencia.
        </p>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad6;
